import React from 'react';
import ChatbotDemo from './components/ChatbotDemo';

function App() {
  return (
    <div className="App">
      <ChatbotDemo />
    </div>
  );
}

export default App;
